module.exports = __webpack_public_path__ + "1be83e8711b7d5f9bccf46f834ba9c68.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/logo.svg
// module id = 16
// module chunks = 0 1